var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaCapabilityImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.25 103.625H75L62.5 88H12.5C10.8424 88 9.25268 88.6585 8.08058 89.8306C6.90848 91.0027 6.25 92.5924 6.25 94.25V188C6.25 189.658 6.90848 191.247 8.08058 192.419C9.25268 193.592 10.8424 194.25 12.5 194.25H156.25C157.908 194.25 159.497 193.592 160.669 192.419C161.842 191.247 162.5 189.658 162.5 188V109.875C162.5 108.217 161.842 106.628 160.669 105.456C159.497 104.283 157.908 103.625 156.25 103.625Z",
    fill: "#FFD55D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 194.25H156.25C157.908 194.25 159.497 193.592 160.669 192.419C161.842 191.247 162.5 189.658 162.5 188V122.375H18.75V194.25Z",
    fill: "#FFC239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 156.75H68.75V181.75H31.25V156.75Z",
    fill: "#FFECAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.625 156.75H59.375V147.375C59.375 144.889 58.3873 142.504 56.6291 140.746C54.871 138.988 52.4864 138 50 138C47.5136 138 45.129 138.988 43.3709 140.746C41.6127 142.504 40.625 144.889 40.625 147.375V156.75H34.375V147.375C34.375 143.231 36.0212 139.257 38.9515 136.326C41.8817 133.396 45.856 131.75 50 131.75C54.144 131.75 58.1183 133.396 61.0485 136.326C63.9788 139.257 65.625 143.231 65.625 147.375V156.75Z",
    fill: "#D7D7D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.375 147.375V156.75H65.625V147.375C65.62 143.233 63.9722 139.261 61.0431 136.332C58.1139 133.403 54.1425 131.755 50 131.75V138C52.4864 138 54.871 138.988 56.6291 140.746C58.3873 142.504 59.375 144.889 59.375 147.375Z",
    fill: "#E5E5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 175.5C34.375 176.329 34.7042 177.124 35.2903 177.71C35.8763 178.296 36.6712 178.625 37.5 178.625H68.75V156.75H34.375V175.5Z",
    fill: "#FFF3C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 84.875H121.875L109.375 97.375V84.875H93.75C92.0924 84.875 90.5027 84.2165 89.3306 83.0444C88.1585 81.8723 87.5 80.2826 87.5 78.625V13C87.5 11.3424 88.1585 9.75268 89.3306 8.58058C90.5027 7.40848 92.0924 6.75 93.75 6.75H187.5C189.158 6.75 190.747 7.40848 191.919 8.58058C193.092 9.75268 193.75 11.3424 193.75 13V78.625C193.75 80.2826 193.092 81.8723 191.919 83.0444C190.747 84.2165 189.158 84.875 187.5 84.875Z",
    fill: "#FFECAE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.875 16.125H165.625V41.125H96.875V16.125Z",
    fill: "#5499C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 166.125H53.125V172.375H46.875V166.125Z",
    fill: "#D7D7D8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M96.875 50.5H184.375V75.5H96.875V50.5Z",
    fill: "#5499C9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M116.541 20.1656L112.5 24.2063L108.459 20.1656L104.041 24.5844L108.081 28.625L104.041 32.6656L108.459 37.0844L112.5 33.0438L116.541 37.0844L120.959 32.6656L116.919 28.625L120.959 24.5844L116.541 20.1656Z",
    fill: "#F2F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.291 20.1656L131.25 24.2063L127.209 20.1656L122.791 24.5844L126.831 28.625L122.791 32.6656L127.209 37.0844L131.25 33.0438L135.291 37.0844L139.709 32.6656L135.669 28.625L139.709 24.5844L135.291 20.1656Z",
    fill: "#F2F2F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.041 20.1656L150 24.2063L145.959 20.1656L141.541 24.5844L145.581 28.625L141.541 32.6656L145.959 37.0844L150 33.0438L154.041 37.0844L158.459 32.6656L154.419 28.625L158.459 24.5844L154.041 20.1656Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.541 54.5406L112.5 58.5812L108.459 54.5406L104.041 58.9594L108.081 63L104.041 67.0406L108.459 71.4594L112.5 67.4187L116.541 71.4594L120.959 67.0406L116.919 63L120.959 58.9594L116.541 54.5406Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.291 54.5406L131.25 58.5812L127.209 54.5406L122.791 58.9594L126.831 63L122.791 67.0406L127.209 71.4594L131.25 67.4187L135.291 71.4594L139.709 67.0406L135.669 63L139.709 58.9594L135.291 54.5406Z",
    fill: "#F2F2F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.041 54.5406L150 58.5812L145.959 54.5406L141.541 58.9594L145.581 63L141.541 67.0406L145.959 71.4594L150 67.4187L154.041 71.4594L158.459 67.0406L154.419 63L158.459 58.9594L154.041 54.5406Z",
    fill: "#F2F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.209 58.9594L172.791 54.5406L168.75 58.5812L164.709 54.5406L160.291 58.9594L164.331 63L160.291 67.0406L164.709 71.4594L168.75 67.4187L172.791 71.4594L177.209 67.0406L173.169 63L177.209 58.9594Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146.875 178.625H153.125V184.875H146.875V178.625Z",
    fill: "#5A5B5D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.125 178.625H140.625V184.875H103.125V178.625Z",
    fill: "#5A5B5D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.875 166.125H153.125V172.375H146.875V166.125Z",
    fill: "#5A5B5D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.125 166.125H140.625V172.375H103.125V166.125Z",
    fill: "#5A5B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaCapabilityImage);
export default __webpack_public_path__ + "static/media/ca-capability-image.99cb08ee.svg";
export { ForwardRef as ReactComponent };